
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"26.32","height":"25.445"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"svg",attrs:{"d":"M13.16 0A13.031 13.031 0 009 25.422c.657.121.87-.284.87-.627v-2.429c-3.661.789-4.423-1.539-4.423-1.539a3.463 3.463 0 00-1.462-1.909c-1.194-.81.091-.792.091-.792a2.76 2.76 0 012.017 1.345 2.815 2.815 0 003.83 1.084 2.758 2.758 0 01.836-1.744c-2.923-.332-6-1.45-6-6.447a5.024 5.024 0 011.355-3.5 4.654 4.654 0 01.133-3.454s1.105-.35 3.62 1.337a12.58 12.58 0 016.59 0c2.512-1.687 3.615-1.337 3.615-1.337a4.649 4.649 0 01.128 3.452 5.011 5.011 0 011.354 3.5c0 5.01-3.078 6.113-6.009 6.436a3.1 3.1 0 01.9 2.415v3.58c0 .347.211.754.878.626A13.032 13.032 0 0013.16 0z"}})])
          )
        }
      }
    